/**
 * The host adapter for the `connections-connect` client-side entity (ADR-029
 * §2). The executor (in `@fias/client-entities`) runs with only
 * `{ userId, archeId }`; the plugin renderer that mounted an arche registers
 * here the function that draws ITS connect sheet, and the executor reaches it
 * by arche id. An arche with no mounted renderer answers CONNECT_UNAVAILABLE.
 */

import type { ConnectionsConnectHost, ConnectionsConnectResult } from '@fias/client-entities';

type SheetHandler = (provider: string) => Promise<ConnectionsConnectResult>;

const handlers = new Map<string, SheetHandler>();

/** Called by the plugin renderer on mount; returns the unregister function. */
export function registerConnectSheet(archeId: string, handler: SheetHandler): () => void {
  handlers.set(archeId, handler);
  return () => {
    if (handlers.get(archeId) === handler) handlers.delete(archeId);
  };
}

export const connectionsConnectHost: ConnectionsConnectHost = {
  async showConnectSheet({ archeId, provider }) {
    const handler = handlers.get(archeId);
    if (!handler) {
      return {
        error: {
          code: 'CONNECT_UNAVAILABLE',
          message: 'Connecting accounts is not available here',
        },
      };
    }
    return handler(provider);
  },
};
